module.exports = __webpack_public_path__ + "static/media/puntos-crecimiento-a.5c1cd7d8.svg";